import React from 'react';
import { styled } from '@compiled/react';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl/src/index.tsx';
import type { MessageDescriptorV2 as MessageDescriptor } from '@atlassian/jira-intl/src/v2/types.tsx';
import { ErrorMessage } from './error-message';
import { LinkToConfluenceSetting } from './link-to-confluence-setting';

type Props = {
	isAdmin: boolean;
	projectKey: string;
	settingMessage: MessageDescriptor;
	errorMessage: MessageDescriptor;
	baseUrl: string;
	warningIconLabel: MessageDescriptor;
};

export const NotLinkConfluenceMessage = ({
	warningIconLabel,
	errorMessage,
	isAdmin,
	...rest
}: Props) => {
	const intl = useIntl();
	return (
		<BannerContainer>
			<StyledWarningIcon>
				<WarningIcon
					label={intl.formatMessage(warningIconLabel)}
					primaryColor={token('color.icon.warning', colors.B400)}
					size="medium"
				/>
			</StyledWarningIcon>
			<div>
				<ErrorMessage errorMessage={errorMessage} />
				{isAdmin && <LinkToConfluenceSetting {...rest} />}
			</div>
		</BannerContainer>
	);
};

// by considering the gridSize is 8 then result should be => 20px 40px 20px 0
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const BannerContainer = styled.div({
	padding: `${token('space.250', '20px')} ${token('space.500', '40px')} ${token(
		'space.250',
		'20px',
	)} 0`,
	display: 'flex',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StyledWarningIcon = styled.div({
	padding: `0 ${token('space.250', '20px')}`,
});
